import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import ScrollToTop from "./components/utility/ScrollToTop";
import GA from "./components/utility/GA";
import Nav from "./components/Nav";
import Top from "./pages/Top";
import './styles/app.scss'
import { InView } from "react-intersection-observer";
import { Footer } from "./components/Footer";
import Products from "./pages/Products";
import Gallery from "./pages/Media";
import { useState, useEffect } from "react";
import Story from "./pages/Story";
import Characters from "./pages/Characters";
import System from "./pages/system/System";
import NewSystem from "./pages/system/NewSystem";
import CombatSystem, { AIBattles, Basic, Hell, Jumbification, KillTech, RankedBattles } from "./pages/system/CombatSystem";
import LevelSystem, { CharacterFeatures, LevelBasic,  ItemReincarnation, Leveling, NetherworldSightseeing, Reincarnation } from "./pages/system/LevelSystem";
import Creation from "./pages/Creation";
import Share from "./pages/Share";
import Plus from "./pages/Plus";
import FlowerPetals from "./components/ui/FlowerPetals";
import Pirilika from "./pages/Pirilika";

function App() {

  const [BGLoaded, setBGLoaded] = useState(false);


  useEffect(() => {
    const img = new Image();
    img.onload = () => {
      setBGLoaded(true);
    };
    img.src = `${process.env.PUBLIC_URL}/img/bg.webp`;

    const img2 = new Image();
    img2.src = `${process.env.PUBLIC_URL}/img/ui/screen_left.webp`;

    const img3 = new Image();
    img3.src = `${process.env.PUBLIC_URL}/img/ui/screen_right.webp`;
  }, []);

  return (
      <div className="App">
      {
        BGLoaded && <Router basename={process.env.PUBLIC_URL}>
        <GA GA4="G-8ZEYQK4SJW"/>
        <Nav/>
        <FlowerPetals/>
        <ScrollToTop>
          <InView>
            <Routes>
              <Route exact path="/" element={<Top/>}/>
              <Route path="story" element={<Story/>}/>
              <Route path="characters" element={<Characters/>}/>
              <Route path="pirilikas-guide" element={<Pirilika/>}/>
              <Route path="system" element={<System/>}>          
                <Route path="combat" element={<CombatSystem/>}>
                  <Route index element={<Jumbification/>}/>
                  <Route path="jumbification" element={<Jumbification/>}/>
                  <Route path="kill-tech" element={<KillTech/>}/>
                  <Route path="ai-battle" element={<AIBattles/>}/>
                  <Route path="basic" element={<Basic/>}/>
                  <Route path="ranked-battle" element={<RankedBattles/>}/>
                  <Route path="hell-mode" element={<Hell/>}/>
                </Route>
                
                <Route path="leveling" element={<LevelSystem/>}>
                  <Route index element={<Leveling/>}/>
                  <Route path="characters" element={<Leveling/>}/>
                  <Route path="reincarnation" element={<Reincarnation/>}/>
                  <Route path="item-reincarnation" element={<ItemReincarnation/>}/>
                  <Route path="basic" element={<LevelBasic/>}/>
                  <Route path="character-features" element={<CharacterFeatures/>}/>
                  <Route path="netherworld" element={<NetherworldSightseeing/>}/>
                </Route>
              </Route>
              <Route path="products" element={<Products/>}/>
              <Route path="gallery" element={<Gallery/>}/>
              <Route path="creation" element={<Creation/>}/>
              <Route path="creation/share" element={<Share/>}/>
              <Route path="whats-new" element={<Plus/>}/>
            </Routes>
          </InView>
        </ScrollToTop>
        <Footer/>
      </Router>
      }
    </div>
  );
}

export default App;
